import * as React from 'react';
import TerminalInstallationReport from './ReportsComposites/TerminalInstallationReport';
import ReportManual from './ReportsComposites/ReportManual';
import {withTranslation} from 'react-i18next';
import i18next from 'i18next';
import {ReportType} from '../../Models/EnumTypes/ReportEnumTypes';

type P = {
    t?: i18next.TFunction;
};
type S = {
    //
};

class InstallationReport extends React.Component<P, S> {
    public render() {
        const {t} = this.props;
        return (
            <div className="main__content">
                <h3 className="main__title">{t('terminalInstallationReport')}</h3>
                <div className="flex flex--wrap">
                    <div className="main__inner-left">
                        <ReportManual reportType={ReportType.TERMINAL_INSTALLATION_REPORT}/>
                    </div>
                    <div className="main__inner-right main__inner-right--flex-4">
                        <TerminalInstallationReport/>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('reports')(InstallationReport as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Raports/InstallationReport.tsx